import { useQuery } from "@tanstack/react-query";
import { qk } from "#/lib/queryKeys";
import {
  ArticleOutline,
  getArticleOutlineById,
} from "#/services/articleOutlines";

export function useArticleOutlineDetail(id?: string) {
  return useQuery<ArticleOutline>({
    queryKey: id ? qk.articleOutlineDetail(id) : ["article-outlines", "detail"],
    queryFn: ({ signal }) => {
      if (!id) {
        return Promise.reject(new Error("Outline id is required"));
      }
      return getArticleOutlineById(id, { signal });
    },
    enabled: Boolean(id),
    staleTime: 30_000,
  });
}

export default useArticleOutlineDetail;
